module.exports = __webpack_public_path__ + "assets/hamburger_mobile-9162e6.svg";